import React, { useEffect } from 'react'
import { useFetch } from '../../../../hooks'
import { getDataByKey, getTitleByKey, renderData, isNotNilDataByKey } from '../../../../helpers'
import Footer from '../../../../modules/Footer'
import Tabs from '../../../../modules/Tabs'
import PageLoader from '../../../../components/PageLoader';
import ZoneStatus from './tabs/ZoneStatus'
import { StyledLinkReport } from './styled'
import { Store } from '../../../../context/store';
import { compose, pathOr, isEmpty, map, pick, head } from 'ramda'
import Icon from '../../../../components/Icon'
import Modal from '../../../../components/Modal'
import { StyledIcon } from '../../../../components/Calendar/styled'
import FormAddZone from '../../components/FormAddZone'
import { useLocation } from 'react-router-dom'


const Zones = () => {
    const { state: { refetch = false } = {} } = useLocation();
    const { actions } = Store();
    const { response, fetching, error, doFetch } = useFetch({
        url: '/zones',
        method: 'GET',
    })

    useEffect(() => {
        const data = getDataByKey(response, "data", {});
        if (!isEmpty(data)) {
            const getZoneList = compose(
                map(pick(['name', 'row_id'])),
                pathOr([], ['params', 'data'])
            );
            actions.setZonesList(getZoneList(data));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [response]);

    useEffect(() => {
        if (refetch) doFetch()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refetch])

    const getLinkReport = () => {
        const getFirstZoneId = compose(
            pathOr(null, ['row_id']),
            head,
            pathOr([], ['data', 'params', 'data']),
            head,
            pathOr([], ['data'])
        );
        const parseData = data => {
            return {
                ...data,
                dates: data.dates && `{${data.dates.join(",")}}`,
                reports: data.reports && `{${data.reports.join(",")}}`
            }
        };
        return {
            pathname: '/reports/zone',
            state: {
                type: "zone",
                dataKey: "row_id",
                icon: "zones",
                data: {
                    ...parseData(getDataByKey(response, 'report')),
                    zoneid: getFirstZoneId(response),
                },
                endpointExecute: "reportzoneexecute",
                refetch: false,
                report: {
                    endpoint: "get_zone_report_modal_data"
                }
            }
        }
    }

    const renderDataState = renderData({ data: response, error, fetching })

    return (
        <>
            {
                renderDataState({
                    fetching: () => (<PageLoader />),
                    error: error => (<div>{error.toString()}</div>),
                    data: data => (
                        <Tabs
                            headBar={{
                                title: getDataByKey(data, 'title', ''),
                                children: (
                                    <Modal
                                        renderOpenButton={
                                            ({ handleToggleIsOpenModal }) => (
                                                <StyledIcon onClick={handleToggleIsOpenModal} name='add' pointer />
                                            )
                                        }
                                    >
                                        {
                                            ({ handleToggleIsOpenModal }) => (
                                                <FormAddZone
                                                    translation={getDataByKey(data, 'zonemodal', {})}
                                                    onClickCancel={handleToggleIsOpenModal}
                                                    refetchZones={doFetch}
                                                />
                                            )
                                        }
                                    </Modal>
                                )
                            }}
                            tabs={[{
                                id: 'zone_status',
                                name: getTitleByKey(data, 'data'),
                                component: <ZoneStatus
                                    zoneStatus={getDataByKey(data, 'data', [])}
                                />,
                                showTab: isNotNilDataByKey(data, 'data')
                            },
                                // {
                                //     id: 'notes',
                                //     name: 'notatki',
                                //     component: <Notes />
                                // }
                            ]}
                        />
                    )
                })
            }
            <Footer>
                {
                    isNotNilDataByKey(response, 'report') &&
                    <StyledLinkReport
                        to={getLinkReport()}
                    >
                        <Icon name='report' />
                    </StyledLinkReport>
                }
            </Footer>
        </>
    )
}

export default Zones